<template>
  <div>
    <el-dialog
      title="新增SN号关联"
      :visible="addSnContactVisible"
      width="100%"
      max-height="600px"
      @close="close"
    >
      <div>
        <el-table
          :data="tableData"
          stripe
          border
          size="small"
          style="width: 100%"
          max-height="600"
          height="600px"
        >
          <el-table-column type="index" width="50" label="序号" />

          <el-table-column
            :prop="item.prop"
            align="center"
            :label="item.lable"
            v-for="(item, index) in tableHeader"
            :key="index"
          >
          </el-table-column>

          <el-table-column prop="statusFlag" label="标签" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="scope.row.statusFlag === 2 ? 'danger' : 'success'"
                >{{ scope.row.statusFlag === 2 ? "需修改" : "正确" }}</el-tag
              >
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="180">
            <template slot-scope="scope">
              <el-button @click="editor(scope.row.id)" type="text" size="small"
                >编辑</el-button
              >
              <el-button type="text" size="small" @click="remove(scope.row.id)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="footer">
        <el-button type="primary" @click="branchAdd">批量添加</el-button>
        <el-button @click="downLoad">下载模板</el-button>
        <el-button @click="close">取 消</el-button>
        <div class="upload">
          <el-upload
            ref="upFileRef"
            accept=".xlsx"
            :headers="upHeaders"
            :action="baseURL + '/snRelation/upload.json'"
            :on-change="upFile"
            v-if="tableData.length > 0 ? false : true"
          >
            <el-button size="normal" type="primary">点击上传</el-button>
          </el-upload>
          <el-button size="normal" type="primary" @click="updataError" v-else
            >提交修改</el-button
          >
        </div>
      </div>
    </el-dialog>

    <!-- 信息修改Dialog -->
    <el-dialog
      title="信息修改"
      :visible.sync="editDialogVisible"
      width="40%"
      :before-close="editClose"
    >
      <el-form :model="editForm" ref="editFormRef" label-width="75px">
        <el-form-item label="错误类型">
          <el-input
            type="textarea"
            v-model="editForm.errorRemark"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="IMEI号" prop="imei">
          <el-input v-model="editForm.imei"></el-input>
        </el-form-item>
        <el-form-item label="SN号" prop="sn">
          <el-input v-model="editForm.sn"></el-input>
        </el-form-item>
        <el-form-item label="simCard" prop="simCard">
          <el-input v-model="editForm.simCard"></el-input>
        </el-form-item>
        <el-form-item label="设备类型" prop="equipmentType">
          <el-input v-model="editForm.equipmentType"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editDialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import instance from "../../api/apiConfig";
export default {
  props: {
    addSnContactVisible: {
      type: Boolean,
    },
  },
  data() {
    return {
      tableData: [],
      tableHeader: [
        {
          lable: "错误提示",
          prop: "errorRemark",
        },
        {
          lable: "IMEI号",
          prop: "imei",
        },
        {
          lable: "SN号",
          prop: "sn",
        },
        {
          lable: "simCard",
          prop: "simCard",
        },
        {
          lable: "设备类型",
          prop: "equipmentType",
        },
      ],
      editForm: {}, //编辑表单数据
      editDialogVisible: false, //编辑框dialog
      baseURL: instance.defaults.baseURL,
      addFile: {}, //上传文件对象
      upHeaders: {
        sessionId: JSON.parse(window.localStorage.getItem("LOGINUSER")).sid,
      }, //文件上传请求头
      updataErrorData: [], //修改完成后的数据
    };
  },
  methods: {
    //下载模板
    downLoad() {
      window.open(`${this.baseURL}/snRelation/downloadTemplate.json`);
    },
    close() {
      this.tableData = [];
      this.editForm = {};
      //请求数据库缓存
      this.$API.clearImportTemp();
      this.$emit("closeDialog");
    },
    //根据id编辑行
    editor(id) {
      this.tableData.forEach((val, index) => {
        if (val.id == id) {
          this.editForm = this.tableData[index];
          this.updataErrorData.forEach((val2, index2) => {
            if (val2.id == id) {
              this.updataErrorData[index2].operatorType = 1;
              this.updataErrorData[index2].row = index2;
            }
          });
          this.editDialogVisible = true;
        }
      });
    },
    //根据id删除行
    remove(id) {
      this.tableData.forEach((val, index1) => {
        if (val.id == id) {
          this.updataErrorData.forEach((val, index2) => {
            if (val.id == id) {
              this.updataErrorData[index2].operatorType = 2;
              this.updataErrorData[index2].row = index2;
            }
          });
          this.tableData.splice(index1, 1);
        }
      });
    },
    //编辑框dialog关闭
    editClose() {
      this.editDialogVisible = false;
    },
    //文件上传
    upFile(file) {
      this.addFile = file;
      if (file.status == "success") {
        //console.log('success')
        this.getTableData();
        this.isUpload = false;
      }
    },
    //批量添加
    branchAdd() {
      if (this.tableData.length <= 0)
        return this.$message.error("请先上传数据");
      let errorFlag = false; //增加错误判断标志，判断tableData是否还有错误数据
      this.tableData.forEach((val) => {
        if (val.statusFlag == 2) return (errorFlag = true);
      });
      if (errorFlag) return this.$message.error("请先修改错误数据");
      this.$message.success("相同的sn号与imei号将会被覆盖，不会新增");
      this.$API.batchAddSnRelation();
      this.close();
    },
    //修改并校验错误结果(返回修改信息)
    updataError() {
      this.$API.updateErrorInfo(this.updataErrorData).then((res) => {
        //console.log(res)
        if (res.status != 200) return this.$message.error("res.msg");
        this.getTableData();
      });
    },

    getTableData() {
      this.$API.getSnRelationImportTemp().then((res) => {
        //console.log(res)
        if (res.code != 0) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        this.tableData = [...res.data];
        this.updataErrorData = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-table {
  border-bottom: 1px solid #ebeef5;
}
.footer {
  display: flex;
  justify-content: flex-end;
  .upload {
    margin-left: 10px;
  }
  /deep/.el-upload-list {
    display: none;
  }
}
.cell button {
  padding: 5px 15px;
}
</style>
